import { Clock, CalendarDays, Sparkles, CheckCircle2 } from "lucide-react";
import Reveal from "@/components/Reveal";

export default function ServiceTimesGrid({ services = [], special, sunday }) {
  return (
    <div className="space-y-10">
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {services.map((s, i) => (
          <Reveal key={s.id} delay={i * 0.08}>
            <div
              data-testid={`service-card-${i}`}
              className="group glass rounded-2xl p-7 h-full transition-all duration-300 hover:-translate-y-1"
              style={{ transition: "transform .3s, border-color .3s, box-shadow .3s" }}
            >
              <div className="flex items-center justify-between mb-5">
                <span className="text-xs font-bold tracking-[0.2em] uppercase text-chapel-red">
                  {s.day}
                </span>
                <span className="w-10 h-10 grid place-items-center rounded-xl bg-chapel-red/10 group-hover:bg-chapel-red transition-colors duration-300">
                  <Clock className="w-5 h-5 text-chapel-red group-hover:text-white" />
                </span>
              </div>
              <h3 className="text-xl font-heading font-bold text-white mb-2">{s.name}</h3>
              <p className="text-2xl font-heading font-extrabold text-chapel-red">{s.time}</p>
            </div>
          </Reveal>
        ))}
      </div>

      {special && special.items?.length > 0 && (
        <Reveal>
          <div
            data-testid="special-services-card"
            className="relative overflow-hidden rounded-3xl p-8 sm:p-10 text-white"
            style={{ background: "linear-gradient(135deg, #E10600, #FF2A2A)" }}
          >
            <div
              className="absolute -top-16 -right-10 w-60 h-60 rounded-full blur-[90px] pointer-events-none"
              style={{ background: "radial-gradient(circle, rgba(255,255,255,0.25), transparent 70%)" }}
            />
            <div className="relative">
              <div className="flex items-center gap-2.5 mb-2">
                <Sparkles className="w-5 h-5 text-white" />
                <span className="text-xs font-bold tracking-[0.2em] uppercase text-white/90">
                  Monthly Special
                </span>
              </div>
              <h3 className="text-2xl sm:text-3xl font-heading font-extrabold text-white mb-1">
                {special.title}
              </h3>
              <p className="text-white/85 mb-7">{special.note}</p>
              <div className="grid gap-4 sm:grid-cols-3">
                {special.items.map((it) => (
                  <div key={it.id} className="rounded-2xl p-5 flex items-center gap-3 bg-white/15 backdrop-blur-sm border border-white/20">
                    <CalendarDays className="w-5 h-5 text-white shrink-0" />
                    <div>
                      <p className="font-heading font-bold text-white">{it.day}</p>
                      <p className="text-sm text-white/85">{it.time}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Reveal>
      )}

      {sunday && sunday.items?.length > 0 && (
        <Reveal>
          <div
            data-testid="sunday-services-card"
            className="relative overflow-hidden rounded-3xl p-8 sm:p-10 text-white"
            style={{ background: "linear-gradient(135deg, #E10600, #FF2A2A)" }}
          >
            <div
              className="absolute -bottom-16 -left-10 w-60 h-60 rounded-full blur-[90px] pointer-events-none"
              style={{ background: "radial-gradient(circle, rgba(255,255,255,0.22), transparent 70%)" }}
            />
            <div className="relative">
              <div className="flex items-center gap-2.5 mb-2">
                <Sparkles className="w-5 h-5 text-white" />
                <span className="text-xs font-bold tracking-[0.2em] uppercase text-white/90">
                  Sunday by Sunday
                </span>
              </div>
              <h3 className="text-2xl sm:text-3xl font-heading font-extrabold text-white mb-1">
                {sunday.title}
              </h3>
              {sunday.note && <p className="text-white/85 mb-7">{sunday.note}</p>}
              <div className="grid gap-4 sm:grid-cols-2">
                {sunday.items.map((it) => (
                  <div key={it.id} className="rounded-2xl p-5 flex items-start gap-3 bg-white/15 backdrop-blur-sm border border-white/20">
                    <CheckCircle2 className="w-5 h-5 text-white shrink-0 mt-0.5" />
                    <div>
                      <p className="text-xs font-bold uppercase tracking-wider text-white/80">{it.label}</p>
                      <p className="font-heading font-bold text-white text-lg leading-tight mt-0.5">{it.name}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Reveal>
      )}
    </div>
  );
}
